import { MembershipType } from '__generatedTypes__/globalTypes'

export const getMembershipLabelByType: Record<MembershipType, string> = {
  [MembershipType.Free]: 'Free Access',
  [MembershipType.Premium]: 'Premium Membership',
  [MembershipType.PremiumMax]: 'Premium Membership Max',
}
